<template>
  <div class="customization-step">
    <template v-if="!loading">
      <!-- stamp or logo -->
      <TeamDecorationBox
        v-if="!customDecorationTextLoading"
        :typeOfDecoration="typeOfDecoration"
        :finalStep="true"
        @clickDecoration="handleClickDecoration"
        @nextLogoStep="uploadCustomLogoStep"
      />
      <Loader v-else />

      <!-- Info -->
      <template v-if="!editMode">
        <div class="customization-help">
          <p>This decoration is used to quickly personalize the {{ customizationStep }} in your showroom.</p>
          <p>You can click on it to adjust the font or colors at any time, or replace it for your own custom graphic or wordmark below.</p>
        </div>

        <!-- Logo upload btn -->
        <div class="customization-logo-upload-link" @click="uploadCustomLogoStep">
          Have your own decoration for your uniforms? Upload it here
        </div>
      </template>

      <!-- Edit -->
      <template v-else>
        <div class="customization-edit">
          <!-- Color Pickers -->
          <div class="input-group">
            <span>Colors</span>
            <div class="color-pickers-container">
              <ColorPicker
                :colorPickerMode="'multiple'"
                :colorsToChange="[tempFill]"
                @selectColor="handleFillColor"
              />
              <ColorPicker
                :colorPickerMode="'multiple'"
                :colorsToChange="[tempOutline]"
                @selectColor="handleOutlineColor"
              />
            </div>
          </div>

          <!-- Mascot -->
          <div class="input-group">
            <span>Text</span>
            <input type="text" v-model="tempMascot">
          </div>

          <div class="input-group" v-if="typeOfDecoration === 'spiritwear'">
            <span>Subtext</span>
            <input type="text" v-model="tempSubMascot">
          </div>
          
          
          <!-- Fonts dropdown -->
          <label class="input-label input-in-row">
            <span>Font</span>
            <v-select
              v-model="tempFont"
              label="name"
              :options="threekitAvailableFonts"
              :clearable="false"
              :searchable="false"
              :disabled="
                threekitAvailableFonts && threekitAvailableFonts.length < 2
              "
              class="box-shadow"
              id="change-fonts"
            ></v-select>
          </label>

          <!-- Save Button -->
          <button type="button" class="save-btn" @click="save()">Save</button>
        </div>
      </template>
    </template>
    <template v-else>
      <Loader />
    </template>

  </div>

  
</template>

<script>
import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";

import TeamDecorationBox from "@/components/Projects/Showrooms/CustomizationBox/TeamDecorationBox.vue";
import Loader from "@/components/Utils/Loader";

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CustomizationBoxDecoration',

  computed: {
    
    ...mapState("showroom", ["customizationStep", "customDecorationTextLoading"]),
    ...mapGetters("showroom", ["getTeamName"]),
    ...mapGetters("project", ["projectColors", "uniformFillColor", "uniformOutlineColor", "spiritwearFillColor", "spiritwearOutlineColor", "uniformMascot", "spiritwearMascot", "spiritwearSubMascot"]),
    ...mapState("project", ["uniformFont", "spiritwearFont"]),
    ...mapState("threekit", {
      threekitFonts: (state) => state.fonts,
    }),
    
    typeOfDecoration() {
      return this.customizationStep === 'spiritwear-decorations'
        ? 'spiritwear' : 'team uniform'
    },

    fillColorPicker() {
      return this.typeOfDecoration === 'spiritwear' ? { color: this.spiritwearFillColor } : { color: this.uniformFillColor }
    },

    outlineColorPicker() {
      return this.typeOfDecoration === 'spiritwear' ? { color: this.spiritwearOutlineColor } : { color: this.uniformOutlineColor }
    },

    threekitAvailableFonts() {
      return this.threekitFonts
    }
    
  },

  methods: {
    ...mapActions("showroom", ["setCustomizationStep", "updateMascotAndColors"]),

    uploadCustomLogoStep() {
      const nextStep = this.customizationStep === 'spiritwear-decorations'
        ? 'spiritwear-custom-logo' : 'uniform-custom-logo'
      this.setCustomizationStep(nextStep)
    },

    handleClickDecoration() {
      this.editMode = true
    },

    handleFillColor(payload) {
      console.log(`Changed fill${this.typeOfDecoration}`, payload)
      this.tempFill = { color: payload.color }
    },

    handleOutlineColor(payload) {
      console.log(`Changed fill${this.typeOfDecoration}`, payload)
      this.tempOutline = { color: payload.color }
    },

    setTempColor() {
      this.tempFill = this.fillColorPicker
      this.tempOutline = this.outlineColorPicker
    },

    save() {
      this.loading = true //I think I should use the global decoration loading but nvm

      setTimeout(() => {
        let payload = {
          mascot: this.tempMascot,
          //colors
        }

        if (this.typeOfDecoration === 'spiritwear') {
          payload['submascot'] = this.tempSubMascot
        }

        //Update mascot, colors and submascot (spiritwear)
        this.updateMascotAndColors(payload) //still in use?

        if (this.typeOfDecoration === 'spiritwear') {

          this.$store.commit("project/SET_SPIRITWEAR_OUTLINE_COLOR", this.tempOutline.color.id );
          this.$store.commit("project/SET_SPIRITWEAR_FILL_COLOR", this.tempFill.color.id );
          this.$store.commit("project/SET_SPIRITWEAR_MASCOT", this.tempMascot );
          this.$store.commit("project/SET_SPIRITWEAR_SUBMASCOT", this.tempSubMascot );
          this.$store.commit("project/SET_SPIRITWEAR_FONT", this.tempFont );

        }
        else {

          this.$store.commit("project/SET_UNIFORM_OUTLINE_COLOR", this.tempOutline.color.id );
          this.$store.commit("project/SET_UNIFORM_FILL_COLOR", this.tempFill.color.id );
          this.$store.commit("project/SET_UNIFORM_MASCOT", this.tempMascot );
          this.$store.commit("project/SET_UNIFORM_FONT", this.tempFont );
          
        }

        this.$emit('return')

        console.log('save')
    
      }, 10)
      
    }
  },

  components: {
    TeamDecorationBox, Loader, ColorPicker
  },

  mounted() {
    this.tempMascot = this.typeOfDecoration !== 'spiritwear' ? this.uniformMascot : this.spiritwearMascot
    this.tempFont = this.typeOfDecoration !== 'spiritwear' ? this.uniformFont : this.spiritwearFont
    this.tempSubMascot = this.spiritwearSubMascot

    this.setTempColor()
  },

  data() {
    return {
      editMode: false,
      loading: false,
      tempMascot: '',
      tempSubMascot: 'ATHLETICS',
      tempFill: null,
      tempOutline: null,
      tempFont: null
    }
  }
}
</script>

<style lang="scss">
  #app {
    .customization-step {
      
      padding: 15px;
      width: 90%;
      .customization-logo-upload-link {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;

        background: #FFFFFF;
        border: 1px solid #D8DADF;
        box-sizing: border-box;
        border-radius: 56px;
        cursor: pointer;
        margin: 20px 10px 0;
      }

      .customization-help {
        margin: 10px 5px;
      }

      .customization-edit {

        .color-pickers-container {
          display: flex;

          .selected-colors {
            margin-right: 25px;
          }

            .color-options {
              position: relative;
              .color-picker-multiple-container {
                width: 322px;
              }
            }
        }
        
        .input-group {
          display: flex;
          flex-direction: column;
          margin: 15px 0;
          span {
            color: #26262C;
          }
          input {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 11px 12px;
            background: #FFFFFF;
            border: 1px solid #D8DADF;
            box-sizing: border-box;
            border-radius: 6px;
            width: 230px;
          }
        }

        .save-btn {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 8px 50px;
          background: #26262C;
          border-radius: 6px;
          margin: 10px auto;
          color: white;
        }
      }
    }
  }
</style>